// TODO: fix
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Apollo fetchMore callback and result shapes depend on the specific query and are forwarded transparently by this helper.
type FetchMoreFunctionType = (options: any) => Promise<any> | undefined;

export async function loadMore(fetchMore: FetchMoreFunctionType, after: unknown, first: number) {
    const response = await fetchMore({
        variables: {
            first: first,
            after: after,
        },
    });
    return response;
}
